import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { HeroContentProp } from './HeroContent';
import type { CategoryNavigationProp } from '../category-navigation/CategoryNavigation';

import { DirectoryHeaderDesktop } from './DirectoryHeader.desktop';
import { DirectoryHeaderMobile } from './DirectoryHeader.mobile';

export interface DirectoryHeaderProps
    extends CategoryNavigationProp,
        HeroContentProp {
    title?: string;
}

const DirectoryHeader: React.FC<DirectoryHeaderProps> = (props) => {
    const { desktop } = useAppDisplayModeContext();

    return desktop ? (
        <DirectoryHeaderDesktop {...props} />
    ) : (
        <DirectoryHeaderMobile {...props} />
    );
};

export default DirectoryHeader;
